var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutputLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1333 8.46667C9.20501 8.46667 8.46667 9.20501 8.46667 10.1333V22.6667C8.46667 23.595 9.20501 24.3333 10.1333 24.3333H22.6667C23.595 24.3333 24.3333 23.595 24.3333 22.6667V21.7333H25.8V22.6667C25.8 24.405 24.405 25.8 22.6667 25.8H10.1333C8.39499 25.8 7 24.405 7 22.6667V10.1333C7 8.39499 8.39499 7 10.1333 7H22.6667C24.405 7 25.8 8.39499 25.8 10.1333V11.0667H24.3333V10.1333C24.3333 9.20501 23.595 8.46667 22.6667 8.46667H10.1333Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0007 17.1341H14.334V15.6675H25.0007V17.1341Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2863 16.3244L20.4297 12.6673L21.4389 11.603L25.3056 15.2697C25.3103 15.2742 25.3149 15.2787 25.3195 15.2833C25.8957 15.8595 25.993 16.8919 25.2869 17.485L21.4389 21.1339L20.4297 20.0697L24.2964 16.403C24.3031 16.3966 24.3099 16.3904 24.3169 16.3843C24.3146 16.3688 24.3066 16.3463 24.2863 16.3244Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutputLight);
export default __webpack_public_path__ + "static/media/icon_output_light.5f3a7391.svg";
export { ForwardRef as ReactComponent };